import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { Observable, of, timer, Subscription } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import {IconsModule } from '../../design-system/icon/icon.module';
import { CommonService } from 'src/app/core/shared-services/common.service';

@Component({
  selector: 'app-toaster',
  standalone: true,
  imports: [
    MatProgressBarModule,
    CommonModule,
    IconsModule,
  ],
  templateUrl: './toaster.component.html',
  styleUrl: './toaster.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class ToasterComponent {


  progress = 0;
  isProgressVisible = true;
  private progressSubscription!: Subscription;
  private duration = 5000; // Default duration for the snackbar

  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: any,
    private snackBarRef: MatSnackBarRef<ToasterComponent>,  // Inject MatSnackBarRef
       public commonService: CommonService,
  ) { }

  ngOnInit() {
    // Set duration dynamically or via data
    this.duration = this.data.duration || 5000;

    // Progress bar logic
    this.progressSubscription = timer(0, 100).pipe(
      takeUntil(timer(this.duration)), // Stop after duration
      map(elapsed => (elapsed / (this.duration / 100)) * 100)
    ).subscribe(value => this.progress = value);

    // Auto-dismiss snackbar after duration
    setTimeout(() => this.snackBarRef.dismiss(), this.duration);
  }

  dismiss() {
    this.snackBarRef.dismiss(); // Correct way to dismiss
  }

  ngOnDestroy() {
    if (this.progressSubscription) {
      this.progressSubscription.unsubscribe();
    }
  }

}
